module.exports = __webpack_public_path__ + "static/img/img13.85868ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c39/img13.png
// module id = Jl1R
// module chunks = 0